<app-navigation-bar></app-navigation-bar>
<div class="container page-content">
  <alert></alert>
  <div class="row justify-content-center">
    <router-outlet></router-outlet>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Please Wait...</p>
</ngx-spinner>